import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {useReservation} from 'context/reservation';
import {usePath} from 'hooks';
import {useGoogleSignIn} from 'hooks/auth/useGoogleSignIn';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {ContinueWithoutLoginButton, SocialAuthButton, SocialButtons} from '../styled';
import {OAUTH_PROVIDER} from '@chekin/core';

const BASE_API_URL = import.meta.env.VITE_APP_BASE_URL;

type Props = {
  onSuccessAuth?: () => void;
  continueWithoutLogin?: boolean;
};
export const SocialLoginButtons = ({
  onSuccessAuth,
  continueWithoutLogin = true,
}: Props) => {
  const {t} = useTranslation();
  const {getFullPath} = usePath();
  const navigate = useNavigate();
  const {allowEditingGuestNumber} = useReservation();
  const {subscribeOAuthGoogleCompletion} = useGoogleSignIn();

  const getContinueWithoutLoginPath = () => {
    const nextPath = allowEditingGuestNumber
      ? PATHS.onboarding.numberOfGuests
      : PATHS.home;

    return getFullPath(nextPath);
  };

  const handleClick = (provider: OAUTH_PROVIDER) => () => {
    window.open(
      `${BASE_API_URL}/api/v1/guest-accounts/oauth/${provider}`,
      '_blank',
      'noopener',
    );
  };

  useEffect(() => {
    const subscriber = subscribeOAuthGoogleCompletion({onSuccess: onSuccessAuth});

    return subscriber.unsubscribe;
  }, [onSuccessAuth, subscribeOAuthGoogleCompletion]);

  return (
    <SocialButtons>
      <SocialAuthButton
        onClick={handleClick(OAUTH_PROVIDER.google)}
        type="button"
        variant="outline"
      >
        <CustomIcon name="google" size={16} />
        {t('auth.continue_with_google')}
      </SocialAuthButton>
      {/*<SocialAuthButton*/}
      {/*  label={t('auth.continue_with_apple')}*/}
      {/*  outlined*/}
      {/*  onClick={handleClick(OAUTH_PROVIDER.apple)}*/}
      {/*  type="button"*/}
      {/*  position="center"*/}
      {/*  iconProps={{position: 'left'}}*/}
      {/*  customIcon={<CustomIcon name="apple" size={16} />}*/}
      {/*/>*/}
      {continueWithoutLogin && (
        <ContinueWithoutLoginButton
          onClick={() => navigate(getContinueWithoutLoginPath())}
          type="button"
          variant="link"
        >
          <CustomIcon name="no-login" size={24} />
          {t('auth.continue_without_logging_in')}
        </ContinueWithoutLoginButton>
      )}
    </SocialButtons>
  );
};
